<script>
  import TypeIcon from './type-icon.svelte'
  import Button from '@components/button.svelte'
  import { Copy } from 'lucide-svelte'
  import { showAlert } from '@lib/utils'
  import searchState from '@state/global-search-state.svelte.js'
  import { highlightQuery } from './highlight.js'
  
  let { item, query = "" } = $props()

  let attributes = $derived(
    item.attributes
      ? Object.keys(item.attributes).filter(key => !["prefix", "name"].includes(key) && ![null, undefined, ""].includes(item.attributes[key]))
      : []
  )

  function copyToClipboard(key) {
    navigator.clipboard.writeText(item.attributes[key])
    showAlert(`${key} copié`, { type: "success" })
  }

  function highlightedText(value) {
    return highlightQuery(value, searchState.highlight ? query : "")
  }
</script>

<!-- The container section that overflow scrolls, no other visual styles -->
<div class="min-h-0 h-full overflow-y-auto flex flex-col w-[50%] border-l border-stone-200/80">

  <!-- The top section with subtle background, content sits botttom left -->
  <section class="details-header px-6 pt-24 pb-3 flex flex-col items-start justify-end relative border-b border-stone-200/80">

    <!-- The type icon sits absolutely near top right -->
    <div class="icon-bg absolute top-3 right-3 p-4 flex items-center justify-center rounded-sm">
      <TypeIcon type={item.prefix} size={20} class="text-gray-400" />
    </div>

    <!-- The titles -->
    <div class="flex flex-col items-start">
      <h6 class="type-label text-smaller text-stone-500 tracking-wide p-[0.25rem] bg-teal-50 -ml-1 leading-4">{item.prefix}</h6>
      <h4 class="name-text text-gray-800 font-medium text-[18px] leading-5">{@html highlightedText(item.label || item.name)}</h4>
    </div>
    
  </section>

  <!-- If we have attributes -->
  {#if item.attributes && Object.keys(item.attributes).length > 0}
    
  <section class="px-6 py-3 h-full overflow-y-auto">
      
      {#each attributes as key}

        <!-- Each item is flex split, has a bit of vertical padding and has a subtle dividing border -->
        <div class="flex items-center justify-between gap-12 py-3 border-b border-stone-100 last-of-type:border-b-0 last-of-type:pb-0">
          <span class="text-gray-500/80 text-smaller leading-4">{key}</span>
          <div class="flex items-center gap-2 -mr-2">
            <span class="text-gray-800 text-smaller text-right leading-4">{@html highlightedText(item.attributes[key])}</span>
            <Button naked Icon={Copy} hint="Copier" iconSize={16} onclick={() => copyToClipboard(key)} class="text-gray-400">
              <Copy size={16} strokeWidth={2.5} />
            </Button>
          </div>
        </div>
      
      {/each}

    </section>
  
  {:else}
    <section class="p-6 flex items-center justify-center">
      <p class="text-gray-500 text-sm">Aucun attribut</p>
    </section>
  {/if}

</div>

<style>
  .details-header {
    background: linear-gradient(45deg, #FAFBFD, #F7F9FE);
  }

  .icon-bg {
    background: #FFF;
    color: #CCCDDB;
  }

  .type-label {
    background: #FFF;
    color: #909195;
  }

  .name-text {
    color: #121826;
  }

  :global(.query-highlight) {
    background: rgba(254, 240, 138, 0.65);
    color: inherit;
    border-radius: 0.125rem;
    padding: 0 0.0625rem;
  }

</style>
